export default function adSpots(el: HTMLElement) {
  const adSpotsAPIUrl = "/spots.json"
  const adSpotsEls: NodeListOf<HTMLElement> =
    el.querySelectorAll("[data-placement]")

  const fetchData = async () => {
    try {
      const response = await fetch(adSpotsAPIUrl)
      const apiResult = await response.json()
      return apiResult
    } catch (error) {
      throw error
    }
  }
  ;(async () => {
    let currentAdspotsResponse: Object = await fetchData()
    adSpotsEls.forEach(adspotEl => {
      let placement = adspotEl.dataset[
        "placement"
      ] as keyof typeof currentAdspotsResponse
      let checksum = "checksum" as keyof typeof currentAdspotsResponse
      let asset_url = "asset_url" as keyof typeof currentAdspotsResponse
      let description = "description" as keyof typeof currentAdspotsResponse
      let link_text = "link_text" as keyof typeof currentAdspotsResponse
      let url = "url" as keyof typeof currentAdspotsResponse

      if (placement) {
        // Compare checksum form DOM and API to replace data if mismatching values
        if (
          adspotEl.dataset["checksum"] !==
          `${currentAdspotsResponse[placement][checksum]}`
        ) {
          let assetEl = adspotEl.querySelector(
            ".adspot-asset",
          ) as HTMLImageElement
          let descriptionEl: HTMLElement | null = adspotEl.querySelector(
            ".adspot-description",
          )
          let linkEl: HTMLAnchorElement | null =
            adspotEl.querySelector(".adspot-link")

          if (!descriptionEl || !linkEl) {
            return
          }
          // Replace asset
          assetEl.src = String(currentAdspotsResponse[placement][asset_url])
          // Check if current ad_spot from API has link_text field
          if (currentAdspotsResponse[placement][link_text]) {
            // Replace descripition text in <p>
            let descriptionText =
              currentAdspotsResponse[placement][description] + " "
            descriptionEl.innerText = descriptionText
            // Replace <a> text and href
            linkEl.innerText = String(
              currentAdspotsResponse[placement][link_text],
            )
            linkEl.href = String(currentAdspotsResponse[placement][url])
            descriptionEl.appendChild(linkEl)
          } else {
            // Clear description
            descriptionEl.innerText = ""
            // Make <a> text the description
            linkEl.innerText = String(
              currentAdspotsResponse[placement][description],
            )
            linkEl.href = String(currentAdspotsResponse[placement][url])
            descriptionEl.appendChild(linkEl)
          }
        }
      }
    })
  })()
}
